import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    globalPhone: 0, // 全局手机号
    taskOpenId: null, // 三认唯一标识
    cartList: [], // 购物车
  },
  getters: {
    getPhone(state) {
      return state.globalPhone
    },
    getOpenid(state) {
      return state.taskOpenId
    },
    getCart(state) {
      return state.cartList
    }
  },
  mutations: {
    setPhone(state, data) {
      state.globalPhone = data
    },
    setOpenid(state, data) {
      state.taskOpenId = data
    },
    setCart(state, data) {
      state.cartList = data
    }
  },
  actions: {
  },
  modules: {
  }
})
